import { deepClone } from './helpers';

/**
 * Creates a stable updateSchema function that doesn't recreate on every render
 * Uses refs to access latest schema and onSchemaChange without causing re-renders
 */
export const createUpdateSchema = (schemaRef, onSchemaChangeRef) => {
  return (updater) => {
    if (!schemaRef.current) return;
    const newSchema = deepClone(schemaRef.current);
    updater(newSchema);
    onSchemaChangeRef.current(newSchema);
  };
};

/**
 * Creates a function to update a specific question field
 */
export const createUpdateQuestionField = (updateSchema, getQuestion) => {
  return (pageIndex, sectionIndex, questionIndex, updater) => {
    updateSchema((newSchema) => {
      const question = getQuestion(newSchema, pageIndex, sectionIndex, questionIndex);
      if (question) updater(question);
    });
  };
};















